import { formatDecimalHoursToHM } from './formatDecimalHoursToHM'

export const getDrawingTime = (code, quantity, printsList) => {
  const printData = printsList.find((p) => p.code === code)
  if(printData) {
    const result = {
      timeForDrawingComplete: null,
      prepareProcessTime: null,
    }
    const {prepare_minutes, hour_rate} = printData
    result.timeForDrawingComplete = hour_rate ? formatDecimalHoursToHM(quantity / hour_rate) : null
    result.prepareProcessTime =  prepare_minutes || null
    return result
  } else {
    return null
  }
}